import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ResourcesHubState} from './resources-hub.reducer';

// Selector functions

const resourcesHubSelector =
  createFeatureSelector<ResourcesHubState>('ss-cord.resources-hub');

export const resourcesHub = createSelector(resourcesHubSelector, state => state);

export const getResourceDetails
  = createSelector(resourcesHubSelector, state => state.resourceDetails);

export const getAddResourcesDetails
  = createSelector(resourcesHubSelector, state => state.addResources)

export const getSessionList = createSelector(resourcesHubSelector, state => state.sessionData)

export const getRolesList = createSelector(resourcesHubSelector, state => state.rolesList)

export const getCategoriesList = createSelector(resourcesHubSelector, state => state.categoriesList)

export const getRelatedResources = createSelector(resourcesHubSelector, state => state.relatedResourcesData)

export const getSessionListForResourceList = createSelector(resourcesHubSelector, state => state.resourceList.session)

export const getRolesListForResourceList = createSelector(resourcesHubSelector, state => state.resourceList.rolesList)

export const getCategoriesListForResourceList = createSelector(resourcesHubSelector, state => state.resourceList.categoriesList)

export const getSubCategoriesForResourceList = createSelector(resourcesHubSelector, state => state.resourceList.subCategoriesList)

export const getResourceList = createSelector(resourcesHubSelector, state => state.resourceList.resources)

export const getResourceStatusList = createSelector(resourcesHubSelector, state => state.resourceList.statusList)

export const getOrganisationsList = createSelector(resourcesHubSelector, state => state.organisationsData)

export const getGroupsList = createSelector(resourcesHubSelector, state => state.groupsData)
